import React, { useContext } from "react";
import TextField from "@mui/material/TextField";
import { MyContext } from "../../../../MyContextApi";

const FONT = "'Host Grotesk', sans-serif";

function CountTextField() {
  const { postCount, setPostCount } = useContext(MyContext);
  const value = String(postCount ?? "");

  const handleChange = (e) => {
    const val = e.target.value;
    if (val.includes("-")) return;
    setPostCount(val);
  };

  let errorMessage = "";
  if (value !== "") {
    if (value.includes(".")) {
      errorMessage = "Please enter a whole number (no decimals)";
    } else {
      const numericValue = parseInt(value, 10);
      if (isNaN(numericValue)) {
        errorMessage = "Invalid number";
      } else if (numericValue > 500) {
        errorMessage = "Enter value below 500";
      }
    }
  }

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <link
        href="https://fonts.googleapis.com/css2?family=Host+Grotesk:wght@400;500;600&display=swap"
        rel="stylesheet"
      />
      <TextField
        className="c-count"
        type="number"
        label="Count"
        error={Boolean(errorMessage)}
        helperText={errorMessage}
        FormHelperTextProps={{
          sx: {
            position: "absolute",
            bottom: "-1.5em",
            margin: 0,
            whiteSpace: "nowrap",
            fontFamily: FONT,
          },
        }}
        sx={{
          position: "relative",
          minWidth: 110,
          "& .MuiInputBase-root": {
            borderRadius: "10px",
            height: "44px",
            fontFamily: FONT,
            fontSize: "13px",
            backgroundColor: "white",
          },
          "& .MuiInputLabel-root": {
            fontFamily: FONT,
            fontSize: "13px",
            "&.Mui-focused": { color: "COLORS.primary" },
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "COLORS.primaryMid",
          },
          "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "COLORS.borderFocus",
            borderWidth: "1.5px",
          },
        }}
        value={value}
        onChange={handleChange}
        inputProps={{ min: 1, max: 500, step: 1 }}
      />
    </div>
  );
}

export default CountTextField;